import { render, staticRenderFns } from "./team.management.vue?vue&type=template&id=f37064b4&scoped=true&"
import script from "./team.management.vue?vue&type=script&lang=js&"
export * from "./team.management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37064b4",
  null
  
)

export default component.exports